import type { TFunction } from "i18next";

import { CharacterFormFields } from "../../types";

// eslint-disable-next-line id-length -- keep "t" as the standard i18n translation helper for readability and tooling support
const getCharacterFormPlaceholders = (t: TFunction) => ({
  [CharacterFormFields.NAME]: t("chatbot:form.placeholder.name"),
  [CharacterFormFields.TITLE]: t("chatbot:form.placeholder.title"),
  [CharacterFormFields.PERSONA]: t("chatbot:form.placeholder.persona"),
  [CharacterFormFields.GREETING]: t("chatbot:form.placeholder.greeting"),
  [CharacterFormFields.SCENARIO]: t("chatbot:form.placeholder.scenario"),
  [CharacterFormFields.DIALOGUE]: t("chatbot:form.placeholder.dialogue"),
  [CharacterFormFields.GUIDELINES]: t("chatbot:form.placeholder.guidelines"),
  [CharacterFormFields.TAGS]: t("chatbot:form.placeholder.tags"),
});

export default getCharacterFormPlaceholders;
